<div [ngClass]='[filterStyle, showSearchText ? "with_search_bar" : formConfig ? "without_search_bar" : ""]' class="fx-row fx-justify-start fx-items-center" style="gap: 32px">
  @if (formConfig) {
    <div class="extra-filters fx-row" style="gap: 32px">
      <button #popoverTarget [disabled]="dataContainerService.loading.value" (click)='showPopover(popoverTarget)' class="desktop-btn fx-row fx-justify-start fx-items-center" style="gap: 8px">
        <span class="material-icons-outlined">filter_list</span>
        <span>Filtra</span>
      </button>
      <button [disabled]="dataContainerService.loading.value" (click)='showMobileFilters()' class="mobile-btn fx-row fx-justify-start fx-items-center" style="gap: 8px">
        <span class="material-icons-outlined">filter_list</span>
        <span>Filtra</span>
      </button>
      @if (filterCount) {
        <button (click)='clearFilters()' class="clear-filters fx-row fx-justify-start fx-items-center" style="gap: 8px">
          <span class="material-icons-outlined">highlight_off</span>
          <span>Rimuovi filtri attivi</span>
        </button>
      }
      <!-- mat menu filters -->
      <!--<ng-container *ngIf='isFiltersOpen'>
      <div class="form-filters fx-column">
        <form-viewer #formViewer
          [record]='filtersData'
          [formConfig]='formConfig'
          [dataContainerService]='dataContainerService'
        ></form-viewer>
        <div class="footer fx-row fx-justify-end fx-items-center">
          <button class="clear-filters" (click)='toggleFilters()'>Annulla</button>
          <button class="apply-filters" (click)='applyFilter(formViewer.getFormData()); toggleFilters();'>Applica</button>
        </div>
      </div>
    </ng-container>-->
  </div>
}

@if (showSearchText) {
  @if ((actionButtons && actionButtons.length > 0) || showSearchText || formConfig) {
    <div (click)='isFiltersOpen = false;' class="search-filter-box fx-row fx-justify-start fx-items-center">
      <input type='text' [placeholder]="'Cerca' | translate" (keydown.enter)='applyFilter(null)' autocomplete="off" [formControl]='defaultSearchControl' class="fx-flex"/>
      @if (!formConfig && defaultSearchControl.value) {
        <mat-icon style='cursor: pointer;' (click)='defaultSearchControl.setValue(""); applyFilter();' matTooltip='Pulisci filtro'>close</mat-icon>
      }
      <mat-icon class="search-icon" style="margin-right: 16px;">search</mat-icon>
      @if (!showSearchText) {
        <div class="fx-flex"></div>
      }
    </div>
  }
}
</div>